import React from "react";

const Mog = ({ isMogging, toggleMog, styles }) => {
  return (
    <div className={styles.mogRow}>
      <span className={styles.effectLabel}>MOGGER</span>
      <button
        onClick={toggleMog}
        className={`${styles.mogToggle} ${isMogging ? styles.mogToggleActive : ""}`}
        aria-pressed={isMogging}
      />
    </div>
  );
};

export default Mog;
